import { Component, Input, EventEmitter, OnInit } from '@angular/core';
import { TagService } from '../services/tag.service';
import { Tag } from '../models/tag.model';

@Component({
    selector: 'tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})

export class TooltipComponent implements OnInit {

    @Input() tag: Tag = new Tag();

    constructor(
        private tagService: TagService
       
        ) {
    }

    visible: boolean = true

    ngOnInit() {
       // this.visible = false;
    }

    toggleVisibility(): void{
        this.tagService.toggleTooltip(this.tag);
    }

}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/tooltip/tooltip.component.ts